<template>
	<div>
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="practice bg_gray">
			<div class="w1200 flex">
				<div class="practice_l bg_white radius8">
					<div class="practice_nav flex tc cl_gray f12px">
						<div v-for="(item,index) in practiceNav" :key="index" class="practice_nav_list" :class="{'on':item.subjectId==currenNav.subjectId}" @click="navCheck(index)">
							<div class="practice_nav_list_img bg_gray">
								<img :src="item.icon" class="block" />
							</div>
							<p class="mat5">{{item.subjectName}}</p>
						</div>
					</div>
					<div class="practice_cont verchose_wrap"  tabindex="0" @click="showDrop_pop=!showDrop_pop"  @blur="showDrop_pop = false">
							<div class="practice_title f20px cl_dark"  style="padding:0 0 0 16px;margin-top:30px" >选择版本
								<span class="version_txt" v-if="drop_active>-1">{{versionList[drop_active].Name}}</span>
								 <i :class="showDrop_pop ? 'arrow-up':'arrow-down'"></i>
								 
							 </div>
				              <div class="drop_menu_popup" v-show="showDrop_pop"  >
								 <ul class="drop_list">
                                     <li v-for="(item,_index) in versionList " :key="_index" :class="['drop_item',_index==drop_active ? 'active':'']" @click.stop="onChangeDropMenu(_index)">{{item.Name}}</li>
			
								 </ul>
							 </div>

					</div>
					<div class="practice_cont mat20">
						<div class="practice_title f20px cl_dark">选择年级</div>
						<div class="practice_div f16px">
							<div v-for="(item,index) in practiceGrade" :key="index" class="cl_gray practice_div_list bg_gray cur"
							 :class="{'on':item.gradeId==grade.gradeId}" @click="gradeCheck(index)">{{item.gradeName}}</div>
						</div>
					</div>
					<div class="practice_cont">
						<div class="practice_title f20px cl_dark">章节列表</div>
						<div class="practice_div f16px">
							<router-link :to="{ path: '/practice_list', query: { chapter_name: item ,subject_id:currenNav.subjectId,grade_id:grade.gradeId,edition_id:versionList[drop_active].Id}}" v-for="(item,index) in practice" :key="index" class="cl_gray practice_div_list bg_gray">{{item}}</router-link>
						</div>
					</div>
				</div>
				<div class="practice_r bg_white radius8">
					<div class="practice_title f20px cl_dark">我的题库</div>
					<img src="../../../static/wrong.png" class="block practice_r_img mat20 mab20" />
					<div class="practice_r_cont f16px">
						<router-link to="/wrong" class="practice_r_list flex">
							<div class="practice_r_list_l">
								<img src="../../../static/wrong_topic.png" class="mar5" />
								<span>错题本</span>
							</div>
							<i class="cl_yel">{{myInfo.user_question_err_num}}</i>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'practice',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 1, //导航
				myInfo: {},
				public: {},
				currenNav: {}, //默认学科
				practiceNav: [], //学科
				practiceGrade: [],  //年级
				grade: {}, //默认年级
				practice: [],
				showDrop_pop:false,
				drop_active:-1,
				versionList:['测试','大是大非','sds']
			}
		},
		mounted() {
			this.getSubject();
		},
		watch:{
			drop_active(newval){
                if(newval>-1){
						this.getGrade();
				}
			}
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//选择版本
			onChangeDropMenu(index){
				
             if(index!=this.drop_active){
				 this.drop_active=index;
				 this.showDrop_pop=false
				 
			 }
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.practiceNav = res.data;
					this.currenNav = this.practiceNav[0];
					this.getVersion()
				});
			},
			//版本
			getVersion(){
			  this.$get("/api/exercise/get_subject_chapter_edition_data",{
				  subject_id:this.currenNav.subjectId,
				  	token: localStorage.getItem("token"),
			  }).then(res=>{
                 this.versionList=res.data;
				 if(this.versionList.length>0){
					 this.drop_active=0;
					 this.getGrade()
				 }
				 else{
					  this.drop_active=-1;
					  
				 }
			})
			},
			//年级
			getGrade () {
				this.$get("/api/exercise/get_grade_data",{
					pharse_id: localStorage.getItem("pharseId"),
					subject_id: this.currenNav.subjectId,
					edition_id:this.versionList[this.drop_active].Id
				})
				.then(res => {
					this.practiceGrade = res.data;
					if (this.practiceGrade.length > 0) {
						this.grade = this.practiceGrade[0];
						this.getChapter();
					} else {
						this.practice = [];
					}
				});
			},
			//章节
			getChapter () {
				this.$get("/api//exercise/get_chapter_data",{
					subject_id: this.currenNav.subjectId,
					grade_id: this.grade.gradeId,
					edition_id:this.versionList[this.drop_active].Id
				})
				.then(res => {
					this.practice = res.data;
				});
			},
			//学科选择
			navCheck (e) {
				this.currenNav = this.practiceNav[e];
				this.getVersion()
			},
			//年级选择
			gradeCheck (e) {
				this.grade = this.practiceGrade[e];
				this.getChapter();
			},
		},
	}
</script>

<style scoped >
.arrow-down{
	border: 10px solid;
	border-color: #AFA9FE transparent transparent transparent;
	height: 0px;
	width: 0px;
	position: relative;
	margin-left: 10px;
	top:20px
}
.arrow-up{
	border: 10px solid;
	border-color:transparent transparent #AFA9FE transparent;
	height: 0px;
	width: 0px;
	position: relative;
	margin-left: 10px;
	top: -15px;


}
.verchose_wrap{
	position: relative;
}
.drop_menu_popup{
	position: absolute;
	bottom: -5px;
	transform: translateY(100%);
	width: 200px;
	height: auto;
	left: 15px;
		   border-radius: 3px;
	    background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
  border-radius: 2px;
  z-index: 999;
  padding: 0.1rem 0px;
  box-sizing: border-box;
  min-height: 30px;

}
.drop_menu_popup .drop_list{

width: 100%;padding: 10px 0px;
box-sizing: border-box;


}
.drop_menu_popup .drop_list .drop_item{
    padding: 0px 15px;
      box-sizing: border-box;
      width: 100%;
      height: 40px;
      line-height:40px;
      text-align: left;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      color: #555;
      font-size: 15px;
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis
;
	  
}
.drop_menu_popup .drop_list .drop_item:hover {
        background: #f7f7f7;
      }
	  .drop_menu_popup .drop_list .active {
        color: #AFA9FE;
      }
	  .version_txt{
		  font-size: 18px;
		  margin-left: 5px;
	  }
</style>
